import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../components/Login.vue'
import Home from '../components/Home.vue'
import Sign from '../components/Sign.vue'
import Frame from '../components/Frame.vue'
import FrameRegister from '../components/FrameRegister.vue'
import FrameRegisterCallback from '../components/FrameRegisterCallback.vue'
import ModifyPassword from '../components/ModifyPassword.vue'
import Register from '../components/Register.vue'
import FrameSealPsn from '../components/FrameSealPsn.vue'
import H5Interaction from '../components/H5Interaction.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Login,
  },
  {
    path: '/login',
    component: Login,
  },
  {
    path: '/home',
    component: Home,
  },
  {
    path: '/sign',
    component: Sign,
  },
  {
    path: '/modifypwd',
    component: ModifyPassword,
  },
  {
    path: '/register',
    component: Register,
  },
  {
    path: '/frame',
    component: Frame,
  },
  {
    path: '/frame-register',
    component: FrameRegister,
  },
  {
    path: '/frame-register-callback',
    component: FrameRegisterCallback,
  },
  {
    path: '/frame-seal-psn',
    component: FrameSealPsn,
  },
  {
    path: '/h5-interaction',
    component: H5Interaction,
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router